import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface DollarSignProps {
  className?: string;
}

export const DollarSignIcon = ({ className = '' }: DollarSignProps) => {
  return <FontAwesomeIcon icon={faDollarSign} className={className} />;
};
